import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EuiTableSortService {

    public sortingParams$ = new BehaviorSubject({ sort: null, order: 'desc' });

    constructor() {}

    setSort(sort: (string | null), order: ('asc' | 'desc' | null)) {
        this.sortingParams$.next({ sort: order ? sort : null, order });
    }
}
